import { z } from "zod/v4";

import { WidgetSchema } from "../../../widgets";

export const PluginWidgetSchema_2023_08_20 = WidgetSchema;
export type PluginWidgetType_2023_08_20 = z.infer<
  typeof PluginWidgetSchema_2023_08_20
>;
